import { useEffect, useRef } from 'react'
import createGeocodingService from '@mapbox/mapbox-sdk/services/geocoding'
import getConfig from 'next/config'

const {
  publicRuntimeConfig: { MAP_BOX_KEY }
} = getConfig()
function useGeocodingService() {
  const geocodingService = useRef<ReturnType<typeof createGeocodingService>>()

  useEffect(() => {
    if (MAP_BOX_KEY) {
      geocodingService.current = createGeocodingService({
        accessToken: MAP_BOX_KEY
      })
    }
  }, [])

  return geocodingService
}

export default useGeocodingService
